package com.sweetlime.bingeamigo.repository

import com.sweetlime.bingeamigo.api.TmdbApi
import com.sweetlime.bingeamigo.model.Episode
import com.sweetlime.bingeamigo.model.Movie
import com.sweetlime.bingeamigo.model.MovieDetail
import com.sweetlime.bingeamigo.model.SeasonDetail
import com.sweetlime.bingeamigo.model.TvShow
import com.sweetlime.bingeamigo.model.TvShowDetail

class TmdbRepository(private val api: TmdbApi) {

    suspend fun getPopularMovies(): List<Movie> {
        return try {
            api.getPopularMovies().results
        } catch (e: Exception) {
            println(e)
            emptyList()
        }
    }

    suspend fun getMovieDetail(movieId: Int): MovieDetail? {
        return try {
            api.getMovieDetail(movieId)
        } catch (e: Exception) {
            null
        }
    }

    suspend fun getPopularTvShows(): List<TvShow> {
        return try {
            api.getPopularTvShows().results
        } catch (e: Exception) {
            println(e)
            emptyList()
        }
    }

    suspend fun searchMovies(query: String): List<Movie> {
        return try {
            api.searchMovies(query).results
        } catch (e: Exception) {
            emptyList()
        }
    }

    suspend fun searchTvShows(query: String): List<TvShow> {
        return try {
            api.searchTvShows(query).results
        } catch (e: Exception) {
            emptyList()
        }
    }

    suspend fun getTvShowDetail(tvShowId: Int): TvShowDetail? {
        return try {
            api.getTvShowDetail(tvShowId)
        } catch (e: Exception) {
            null
        }
    }

    suspend fun getSeasonDetail(tvShowId: Int, seasonNumber: Int): SeasonDetail? {
        return try {
            api.getSeasonDetail(tvShowId, seasonNumber)
        } catch (e: Exception) {
            null
        }
    }

    suspend fun getEpisodeDetail(tvShowId: Int, seasonNumber: Int, episodeNumber: Int): Episode? {
        return try {
            api.getEpisodeDetail(tvShowId, seasonNumber, episodeNumber)
        } catch (e: Exception) {
            null
        }
    }
}